import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import ReactDOM from "react-dom";
import React from "react";

import "react-app-polyfill/stable";
import "react-app-polyfill/ie11";

import * as serviceWorker from "./serviceWorker";
import store from "./store";
import App from "./App";
import "./index.css";

const novoTitulo = [document.title].join(" ");
document.title = novoTitulo;

const app = (
  <Provider store={store}>
    <BrowserRouter basename="/">
      <App />
    </BrowserRouter>
  </Provider>
);

ReactDOM.render(app, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
